
import Layout from '@/views/Layout.vue'
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  reactive,
  ref
} from 'vue'
import PersonalityButton from '@/components/common/PersonalityButton.vue'
import { useRoute } from 'vue-router'
import config from '@/config'
import { getNonceAPIHandler } from '@/composables/aes'
import Loading from '@/components/common/loading.vue'
import RedpackInfo from '@/components/RedpackInfo.vue'
import { useRecaptcha } from '@/composables/recaptcha'

export default defineComponent({
  name: 'Share',
  components: {
    Layout,
    PersonalityButton,
    Loading,
    RedpackInfo
  },

  setup () {
    const route = useRoute()

    const query = route.query as {
      redPackId: string;
      chainId: string;
      chainIdInit: string;
      nonce: string
    }

    console.log(route)

    const loading = ref(false)

    const link = computed(() => {
      return `${
        location.origin + process.env.VUE_APP_BASEURL
      }/receive?redPackId=${query.redPackId}&chainId=${
        query.chainId
      }&chainIdInit=${query.chainIdInit}&skin=${config.skinImage}&nonce=${
        query.nonce
      }`
    })

    async function shareHandler () {
      window.fxwallet.sendMessage(
        'open_share',
        link.value,
        (err: any, res: any) =>
          console.log('sendMessage', 'open_share', err, res)
      )
    }

    async function copyHandler () {
      window.fxwallet.sendMessage('copy', link.value, (err: any, res: any) => {
        console.log('sendMessage', 'copy', err, res)
      })
    }

    return {
      copyHandler,
      shareHandler,
      query,
      loading
    }
  }
})
